import saveAs from "file-saver";
import isArray from "lodash/isArray";

type UseDownloadReturn = (fileName: string, content: BlobPart | BlobPart[], fileType: string) => void;

export const useDownload =
  (): UseDownloadReturn => (fileName: string, content: BlobPart | BlobPart[], fileType: string) => {
    const blob = new Blob(isArray(content) ? content : [content], {
      type: fileType
    });

    return saveAs(blob, fileName);
  };
